import React from 'react';
import { Trash2 } from 'lucide-react';

const TriviaItemBlock = ({ block, onUpdate, onDelete }) => {
  return (
    <div className="block-item trivia-block">
      <div className="block-header">
        <span>Trivia Question</span>
        <button
          type="button"
          className="btn-icon-small delete"
          onClick={() => onDelete(block.id)}
        >
          <Trash2 size={16} />
        </button>
      </div>
      <textarea
        placeholder="Question"
        value={block.question || ''}
        onChange={(e) => onUpdate(block.id, { question: e.target.value })}
        className="field-textarea"
      />
      <input
        type="text"
        placeholder="Option A"
        value={block.optionA || ''}
        onChange={(e) => onUpdate(block.id, { optionA: e.target.value })}
        className="field-input"
      />
      <input
        type="text"
        placeholder="Option B"
        value={block.optionB || ''}
        onChange={(e) => onUpdate(block.id, { optionB: e.target.value })}
        className="field-input"
      />
      <input
        type="text"
        placeholder="Option C"
        value={block.optionC || ''}
        onChange={(e) => onUpdate(block.id, { optionC: e.target.value })}
        className="field-input"
      />
      <input
        type="text"
        placeholder="Option D"
        value={block.optionD || ''}
        onChange={(e) => onUpdate(block.id, { optionD: e.target.value })}
        className="field-input"
      />
      <select
        value={block.correct || 'A'}
        onChange={(e) => onUpdate(block.id, { correct: e.target.value })}
        className="field-select"
      >
        <option value="A">Correct: A</option>
        <option value="B">Correct: B</option>
        <option value="C">Correct: C</option>
        <option value="D">Correct: D</option>
      </select>
      <textarea
        placeholder="Explanation"
        value={block.explanation || ''}
        onChange={(e) => onUpdate(block.id, { explanation: e.target.value })}
        className="field-textarea"
      />
    </div>
  );
};

export default TriviaItemBlock;
